// extracted by mini-css-extract-plugin
export var action = "Footer-module--action--KTWOW";
export var bold = "Footer-module--bold--Loj4k";
export var bottom = "Footer-module--bottom--cvaZT";
export var bottomBox = "Footer-module--bottomBox--CwTuo";
export var box = "Footer-module--box--Vl-0G";
export var copyright = "Footer-module--copyright--C6FdS";
export var cta = "Footer-module--cta--2TWBI";
export var image = "Footer-module--image--bYcp5";
export var logo = "Footer-module--logo--sPTyT";
export var logoMobile = "Footer-module--logoMobile--Q20Gw";
export var navBox = "Footer-module--navBox--KiRV1";
export var root = "Footer-module--root--k6EnZ";
export var socialLinks = "Footer-module--socialLinks--sPy4T";
export var spacer = "Footer-module--spacer--BYETm";
export var title = "Footer-module--title--mq-YF";
export var train = "Footer-module--train--Ois7c";
export var trainBox = "Footer-module--trainBox--XaOph";